import { useCallback } from 'react'

import { useNotification } from '@/hooks'
import { trafficAreasUtils } from '@/utils'

import { useTrafficProfile } from '../../../../hooks/useTrafficProfile'

import { useTrafficAreas } from './useTrafficAreas'

import { useDeleteTrafficAreaModal } from '../../../../../../../../modals/DeleteTrafficAreaModal'

export function useActions() {
  const toast = useNotification()
  const trafficProfile = useTrafficProfile()
  const trafficAreas = useTrafficAreas()
  const { show: showDeleteTrafficAreaModal } = useDeleteTrafficAreaModal()

  const profileId = trafficProfile.id

  const onDelete = useCallback(() => {
    showDeleteTrafficAreaModal()
  }, [showDeleteTrafficAreaModal])

  const onExport = useCallback(() => {
    try {
      trafficAreasUtils.exportAreasToKML(trafficAreas, profileId)
    } catch (e) {
      toast.error(e.message)
    }
  }, [toast, trafficAreas, profileId])

  return {
    onDelete,
    onExport,
  }
}
